import { render, staticRenderFns } from "./FitImg.vue?vue&type=template&id=fd4b6326&scoped=true&"
import script from "./FitImg.vue?vue&type=script&lang=js&"
export * from "./FitImg.vue?vue&type=script&lang=js&"
import style0 from "./FitImg.vue?vue&type=style&index=0&id=fd4b6326&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4b6326",
  null
  
)

export default component.exports